import mime from 'mime-types';

function isGeojsonFileType(file: File) {
	const type = mime.lookup(file.name) || '';
	return ['application/json', 'application/geo+json'].includes(type);
}

export { isGeojsonFileType };
